import {
  COMPONENT_MODIFIED,
  COMPONENT_SAVE_REQUESTED,
  COMPONENT_SAVE_REJECTED,
  COMPONENT_SAVE_FULFILLED,
  CLEAR_COMPONENT_API_RESPONSE,
  DYNAMIC_VALUES_REQUESTED,
  DYNAMIC_VALUES_FULFILLED,
  DYNAMIC_VALUES_REJECTED,
  IS_FETCHING_COMPONENT,
  UNPUBLISH_COMPONENT_REQUESTED,
  UNPUBLISH_COMPONENT_FULFILLED,
  UNPUBLISH_COMPONENT_REJECTED
} from './const';

/**
 * Returns action for component modification
 * @param {string} value - object containing component data.
 * @param {string} schemaField - object containing component data.
 * @param {string} id - id of the component being modified.
 * @returns {object} Action Object
 */
export const modifyComponent = (value, schemaField, id) => {
  return { type: COMPONENT_MODIFIED, id, value, schemaField };
};

/**
 * Returns action for component save (add and update)
 * @param {string} editStatus - edit state of current component
 * @param {object} component - object containing component data.
 * @returns {object} Action Object
 */
export const saveComponent = (editStatus, component) => ({
  type: COMPONENT_SAVE_REQUESTED,
  editStatus,
  component
});

/**
 * Returns action for component save (add and update) success
 * @param {object} component - object containing component data.
 * @param {object} response - response object from save component api call.
 * @returns {object} Action Object
 */
export const saveComponentSuccess = (component, response) => ({
  type: COMPONENT_SAVE_FULFILLED,
  component,
  response
});

/**
 * Returns action for component save (add and update) failure
 * @param {object} component - object containing component data.
 * @param {object} error - object containing error from component save api call.
 * @returns {object} Action Object
 */
export const saveComponentFailure = (component, error) => ({
  type: COMPONENT_SAVE_REJECTED,
  component,
  error
});

/**
 * Returns action to clear page api response/error
 * @returns {object} Action Object
 */
export const clearComponentApiResponse = () => ({
  type: CLEAR_COMPONENT_API_RESPONSE
});

/**
 * return action for contract dynamic allowed values request
 * @param {object} fieldContract - contract for the field needing dynamic values
 * @returns {object} action
 */
export const getDynamicValues = fieldContract => ({
  type: DYNAMIC_VALUES_REQUESTED,
  fieldContract
});

/**
 * return action for contract dynamic allowed values success
 * @param {object} fieldContract - contract for the field needing dynamic values
 * @param {Array} allowedValues - array of allowed values
 * @returns {object} action
 */
export const getDynamicValuesSuccess = (fieldContract, allowedValues) => ({
  type: DYNAMIC_VALUES_FULFILLED,
  allowedValues,
  fieldContract
});

/**
 * return action for contract dynamic allowed values failure
 * @param {Error} error - error object causing failure
 * @returns {object} action
 */
export const getDynamicValuesFailure = error => ({
  type: DYNAMIC_VALUES_REJECTED,
  error
});

/**
 * unpublish component request action
 * @param {object} component - object containing component data.
 * @returns {object} Action Object
 */
export const unpublishComponentRequest = component => ({
  type: UNPUBLISH_COMPONENT_REQUESTED,
  component
});

/**
 * unpublish component success action
 * @param {object} component - object containing component data.
 * @param {object} response - response object from save component api call.
 * @returns {object} Action Object
 */
export const unpublishComponentSuccess = (component, response) => ({
  type: UNPUBLISH_COMPONENT_FULFILLED,
  component,
  response
});

/**
 * unpublish component failure action
 * @param {object} component - object containing component data.
 * @param {object} error - object containing error from component save api call.
 * @returns {object} Action Object
 */
export const unpublishComponentFailure = (component, error) => ({
  type: UNPUBLISH_COMPONENT_REJECTED,
  component,
  error
});

/**
 * fetch component in progress
 * @param {object} bool - fetch component in progress bool
 * @returns {object} Action Object
 */
export const isFetchingComponent = bool => ({
  type: IS_FETCHING_COMPONENT,
  bool
});
